export default __webpack_public_path__ + "img/57ab192ed642923b0338f66cc07417b0.svg";